import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to take control.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>An orchestra is a collection of highly talented, dedicated
                                                individuals, but only one person, the conductor,
                                                can assume responsibility and take control of proceedings. If
                                                this doesn’t happen, chaos results.</p>
                                            <div className="border_subtitle">The right blend</div>
                                            <p>The study below shows the types of qualities that might make up a
                                                great conductor. Just like an
                                                orchestra conductor, understanding how and when to take control
                                                is one of the critical attributes of
                                                being a leader. Vroom &amp; Jago<a className="superscripttext"
                                                                                   href="further_info.php?course=300"><sup>1</sup></a> outlined
                                                some common decision making styles of leaders ranging from
                                                making decisions alone, consulting with others before making
                                                decisions, to having a fully collaborative
                                                approach. They noted that each approach has its own merits but
                                                all have far reaching consequences.</p>
                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <div className="border_subtitle">Virtuoso performance?</div>
                                                <p>In 2007, two psychologists, Boerner &amp; von Streit,<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>2</sup></a> examined
                                                    orchestral performance. They
                                                    found two key elements; suggesting that the orchestra’s
                                                    individual players must be emotionally
                                                    ‘in tune’ with each other and also that leadership style of
                                                    the conductor affects group success.</p>
                                                <p>They studied 22 German orchestras, looking at leadership
                                                    style (as well as cohesiveness of
                                                    the orchestra), and rated the orchestras on their overall
                                                    level of artistic quality.</p>
                                                <div className="uiheading"><p>The results showed that the most
                                                    highly rated orchestras had conductors who were
                                                    charismatic (the orchestra was proud to work with them),
                                                    inspirational (motivate the orchestra
                                                    by making it clear what is required) and intellectually
                                                    stimulating (often suggest new
                                                    interpretations).</p></div>
                                            </div>
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Taking control is a demanding process – the manager or team
                                                leader has to understand if their
                                                approach and abilities are matched to the task and the people at
                                                hand. Awareness of our
                                                strengths and limitations is necessary if sound decision making
                                                is to result. This tool is all about
                                                <span className="brown brownbold">how to take control</span> and
                                                will help you to reflect on types of control and provide you
                                                with guidance
                                                on taking control of situations.</p>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}